import new_player_download from "@/components/new-player/modules/new_player_download";

export default async (context) => {
    new_player_download(context)
}